import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

import { GetPaymentMethodResponse } from '../../../Api/CRM/Responses/PaymentMethodResponse';
import axios from '../../services/MyAxios';

import PaymentMethodChannelDetails from './PaymentMethodChannelDetails';

type Params = {
    id: string;
};

function PaymentMethodChannelShow() {
    const { id } = useParams<Params>();
    const [paymentMethodChannel, setPaymentMethodChannel] = useState<GetPaymentMethodResponse | {}>({});
    const url = `/crea/api/payment_method_channel/${id}`;

    function getPaymentMethodChannel() {
        axios.get(url).then((response) => {
            setPaymentMethodChannel(response.data);
        });
    }

    useEffect(() => {
        getPaymentMethodChannel();
    }, []);

    return (
        <div>
            <PaymentMethodChannelDetails paymentMethodChannel={paymentMethodChannel} />
            <Link to={`/payment_method_channels/${id}/edit`} className="btn btn-default">
                Edit
            </Link>
        </div>
    );
}

export default PaymentMethodChannelShow;
